// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from "@mui/material/CircularProgress";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";

function Settings({ spray, setSpray, operators }) {
  const handleSelectOperator = (x) => {
    if (!spray.operatorWorker.includes(x)) {
      setSpray((prevState) => ({
        ...prevState,
        operatorWorker: [...prevState.operatorWorker, x],
      }));
    } else {
      setSpray((prevState) => ({
        ...prevState,
        operatorWorker: [...prevState.operatorWorker.filter((worker) => worker !== x)],
      }));
    }
  };

  const handleSelectPPE = (x) => {
    if (!spray.PPE.includes(x)) {
      setSpray((prevState) => ({
        ...prevState,
        PPE: [...prevState.PPE, x],
      }));
    } else {
      setSpray((prevState) => ({
        ...prevState,
        PPE: [...prevState.PPE.filter((item) => item !== x)],
      }));
    }
  };

  const PPE = ["Goggles/Face Shield", "Spray Suit", "Gloves", "Respirator", "Full PPE"];

  return (
    <MDBox>
      <Grid container spacing={2} sx={{ padding: 3 }}>
        <Grid item xs={12} md={6} lg={6}>
          <FormControl size="large" sx={{ width: "100%" }}>
            <InputLabel id="target-area">
              <Icon
                sx={{
                  fontWeight: "bold",
                  color: ({ palette: { success } }) => success.main,
                  paddingRight: 2,
                }}
              >
                person
              </Icon>
              Operator(s)
            </InputLabel>
            <Select
              sx={{ height: "50px" }}
              multiple
              labelId="operator-label"
              id="operator-select"
              value={spray.operatorWorker}
              label="Operatorss__"
            >
              {operators.length > 0 ? (
                operators.map((op) => (
                  <MenuItem
                    key={op.key}
                    value={op.name}
                    onClick={() => {
                      handleSelectOperator(op.name);
                    }}
                  >
                    {op.name}
                  </MenuItem>
                ))
              ) : (
                <CircularProgress color="success" />
              )}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          <FormControl size="large" sx={{ width: "100%" }}>
            <InputLabel id="target-area">
              <Icon
                sx={{
                  fontWeight: "bold",
                  color: ({ palette: { success } }) => success.main,
                  paddingRight: 2,
                }}
              >
                warning
              </Icon>
              PPE Required
            </InputLabel>
            <Select
              sx={{ height: "50px" }}
              multiple
              labelId="operator-label"
              id="operator-select"
              value={spray.PPE}
              label="PPE Required___"
            >
              {PPE.length > 0 ? (
                PPE.map((item) => (
                  <MenuItem
                    key={item}
                    value={item}
                    onClick={() => {
                      handleSelectPPE(item);
                    }}
                  >
                    {item}
                  </MenuItem>
                ))
              ) : (
                <CircularProgress color="success" />
              )}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={12} lg={12}>
          <TextField
            sx={{
              width: "100%",
              "& .MuiInputBase-root": {
                height: 50,
              },
            }}
            value={spray.notes}
            label="Notes"
            onChange={(e) => {
              setSpray((prevState) => ({
                ...prevState,
                notes: e.target.value,
              }));
            }}
          />
        </Grid>
      </Grid>
    </MDBox>
  );
}

// Typechecking props
Settings.propTypes = {
  operators: PropTypes.objectOf(
    PropTypes.oneOf([PropTypes.string, PropTypes.array, PropTypes.object])
  ).isRequired,
  spray: PropTypes.objectOf(PropTypes.oneOf([PropTypes.string, PropTypes.array, PropTypes.object]))
    .isRequired,
  setSpray: PropTypes.func.isRequired,
};

export default Settings;
